import { useCallback } from 'react';
import { useLoginContext } from '../reducer/useLogin';
import { verifyOtp } from '../../rest-api/request';
import { persistAuthResult } from '@xolv-mybrightlink/common';
import { parseAuthError } from '../../rest-api/utils';

export const useVerifyOTP = () => {
  const [state, dispatch] = useLoginContext();
  return useCallback(
    async (otp: string) => {
      if (state.data.type !== 'VERIFYING_OTP') {
        return;
      }
      const phoneNumber = state.data.phoneNumber;
      dispatch('LOADING');
      try {
        const authResult = await verifyOtp(phoneNumber, otp);
        persistAuthResult(authResult.access_token, authResult.refresh_token);
        dispatch({ type: 'VERIFYING_OTP_SUCCESS', phoneNumber });
      } catch (error) {
        dispatch({
          type: 'VERIFYING_OTP',
          phoneNumber,
          error: getErrorReason(error),
        });
      }
    },
    [state, dispatch],
  );
};

const getErrorReason = (error: unknown) => {
  const errorResponse = parseAuthError(error);
  const errorCode = errorResponse?.error_code;
  if (errorCode === 'BAD_CREDENTIALS') {
    return 'bad-credentials';
  } else if (errorCode === 'OTP_EXPIRED') {
    return 'expired';
  } else {
    return 'generic-error';
  }
};
